export default __webpack_public_path__ + "KaTeX_SansSerif-Regular.5af9e1cfc966c7b16e7615fa66a29955.ttf";